<template>
    <div class="h-full overflow-y-auto">
        <sub-account-ledger :sub-account-getter="getAccountsReceivable" is-customer />
    </div>
</template>

<script setup lang="ts">
import {useSubAccounts} from '@/subaccount/subAccount.service'
import SubAccountLedger from '@/subaccount/outstandingBalance/SubAccountLedger.vue'

const {getAccountsReceivable} = useSubAccounts()

</script>